// Creates the axios instance and adds the interceptor for authentication in all requests
import axios, { AxiosError, AxiosRequestConfig } from "axios"

export function mapApiUrl(): string {
  const baseURL = process.env.API_URL

  if (!baseURL) {
    throw new Error("API URL not found")
  }

  return baseURL
}

export function authorizationInterceptor(config: AxiosRequestConfig<unknown>) {
  if (config.headers?.Authorization) return config

  const token = localStorage.getItem("token")

  if (!token) return config

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${token}`
  }

  return config
}

export function refreshTokenInterceptor(error: AxiosError<{ message?: string }>) {
  if (error.response?.status === 401 || error.response?.status === 403) {
    localStorage.clear()
    if (window.location.pathname !== "/login") {
      window.location.href = "/login"
    }
  }

  return Promise.reject(error)
}

export const api = axios.create({
  baseURL: mapApiUrl()
})

api.interceptors.request.use(authorizationInterceptor)

api.interceptors.response.use((response) => {
  return response
}, refreshTokenInterceptor)
